export interface ISchoolDTO {
  id: number;
  createdBy?: number;
  deletedAt?: string;
  deletedBy?: number;
  schoolName: string;
}

export class SchoolDTO implements ISchoolDTO {
  id: number = 0;
  createdBy?: number = 0;
  deletedAt?: string = '';
  deletedBy?: number = 0;
  schoolName: string = '';

  constructor(configOverride?: Partial<ISchoolDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ISchoolRequest {
  schoolName: string;
}

export class SchoolRequest implements ISchoolRequest {
  schoolName: string = '';

  constructor(configOverride?: Partial<ISchoolRequest>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export class SchoolSearchResultDto {
  name: string;

  address: string;

  placeId: string;

  latitude?: number;

  longitude?: number;

  rating?: number;

  types?: string[];
}

export class SchoolSearchResponseDto {
  schools: SchoolSearchResultDto[];
}
